import { call, put } from "redux-saga/effects";
import searchDeals from "../../api/dealsApi";
import { Types } from "../actionTypes";

export function* getDeals(action) {
  try {
    const params = {};
    yield call(searchDeals, params, onSuccess, onError);
  } catch (e) {
    onError(e);
  }
}

function* onSuccess(response) {
  yield put({ type: Types.FETCH_DEALS_SUCCESS, response });
}

function* onError(response) {
  yield put({ type: Types.FETCH_DEALS_FAILURE, response });
}
